/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateTherapistScenarioRequest = {
    email?: string;
    password?: string;
    firstName?: string;
    lastName?: string;
    therapistName?: string;
    plan?: CreateTherapistScenarioRequest.plan;
    isMultiUserManager?: boolean;
    featurePaymentEnabled?: boolean;
};
export namespace CreateTherapistScenarioRequest {
    export enum plan {
        FREE = 'free',
        PAID = 'paid',
        MULTI_USER = 'multiUser',
    }
}

